/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable import/order */
import {
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FC, memo, useMemo } from 'react';
import { styles } from '@bvi/admin-panel/feature/manage-list/ui/manage-base-table/style';
import { useTranslation } from 'react-i18next';
import { useGetDamageListQuery } from '@bvi/admin-panel/entities/damage/api-slice';
import { selectDamage } from '@bvi/admin-panel/entities/damage/selectors';
import { Span } from '@bvi/common-components';
import { IDamageData } from '@bvi/api-interfaces/response/manage-base-data';
import { DamageTableRow } from './damage-row';

interface IDamagesTableProperties {
  query: string;
}

const DamagesTableComponent: FC<IDamagesTableProperties> = ({
  query,
}) => {
  const { t } = useTranslation();

  const { data: damageList, isLoading: isDamageLoading } = useGetDamageListQuery(
    undefined,
    {
      selectFromResult: ({ data, isLoading }) => ({
        data: selectDamage(data),
        isLoading,
      }),
    },
  );

  const filteredAndSorted = useMemo(() => {
    const list = query
      ? damageList.filter((s: IDamageData) => {
          const lower = query.toLowerCase();
          return (
            String(s.id).includes(lower) ||
            (s.name?.toLowerCase().includes(lower) ?? false)
          );
        })
      : [...damageList];

    return list.sort((a: IDamageData, b: IDamageData) => {
      const nameA = a.name?.toLowerCase() ?? '';
      const nameB = b.name?.toLowerCase() ?? '';
      return nameA.localeCompare(nameB);
    });
  }, [query, damageList]);

  const tableColumns = [
    {
      title: t('manageBaseTable.table.columns.id'),
      width: '10%',
    },
    {
      title: t('manageBaseTable.table.columns.name'),
      width: '60%',
    },
    {
      title: t('manageBaseTable.table.columns.createdAt'),
      width: '20%',
    },
    {
      width: '70px',
    },
  ];

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={styles.fixedTable}>
          <TableHead>
            <TableRow>
              {tableColumns.map((column, index) => (
                <TableCell width={column.width} key={index}>
                  {column.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isDamageLoading ? (
              <TableRow>
                <TableCell colSpan={tableColumns.length} align="center">
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <CircularProgress size={24} />
                  </Stack>
                </TableCell>
              </TableRow>
            ) : (
              filteredAndSorted.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={tableColumns.length} align="center">
                    <Span>{t('manageBaseTable.table.results.empty')}</Span>
                  </TableCell>
                </TableRow>
              ) : (
                filteredAndSorted.map(
                  (damage: IDamageData) => (
                    <DamageTableRow
                      damage={damage}
                      key={damage.id}
                    />
                  ),
                )
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export const DamagesTable = memo(DamagesTableComponent);

